const ViewUserInfo = () => import('../modules/register/ViewUserInfo')
const ViewPersonUserInfo = () => import('../modules/personuser/PagePersonUser')
const SubAccountsManager = () => import('../modules/SubAccounts/SubAccountsManager')
const RecoverPwd = () => import('../modules/register/RecoverPwd')
const ManagerPhone = () => import('../modules/MobileMarketingModule/managerphone.vue')
const managerScanCodeReg = () => import('../modules/ScancodeRegManager/managerScanCodeReg.vue')
const Suggest = () => import('../modules/zcfw/suggest/SuggestManager.vue')
const Scexpert = () => import('../modules/zcfw/scexpert/ScexpertManager.vue')
const Fgexpert = () => import('../modules/zcfw/scexpert/FgexpertManager.vue')
const ExpertInfo = () => import('../modules/expertinfo/PageExpertInfo')
const ActivityManager = () => import('../modules/zcfw/serviceActivity/ActivityManager.vue')
const WximgManager = () => import('../modules/zcfw/wximg/WximgManager.vue')
const AppSurveyManager = () => import('../modules/zcfw/appSurvey/AppSurveyManager')
const ScActiveCompany = () => import('../modules/zcfw/activeCompany/ScActiveCompanyList.vue')
const ScImportStores = () => import('../modules/zcfw/importStores/ScImportStores.vue')
export default [
  {

    path: '/userinfo',
    name: 'userinfo',
    component: ViewUserInfo,
    meta: {
      title: '用户信息',
      isBlack: true
    },
  },
  {

    path: '/personUserInfo',
    name: 'personUserInfo',
    component: ViewPersonUserInfo,
    meta: {
      title: '个人用户信息',
      isBlack: true
    }
  },
  {
    path: '/subaccounts',
    name: 'subaccounts',
    component: SubAccountsManager,
    meta: {

      title: '子账号管理',
      isBlack: true
    },
  },
  {
    path: '/recoverpwd',
    name: 'RecoverPwd',
    component: RecoverPwd,
    meta: {

      title: '找回密码审核',
      isBlack: true
    },
  },
  {
    path: '/managerphone',
    name: 'ManagerPhone',
    component: ManagerPhone,
    meta: {
      title: '手机号码管理',
      isBlack: true
    },
  },
  {
    path: '/managerScanCodeReg',
    name: 'managerScanCodeReg',
    component: managerScanCodeReg,
    meta: {
      title: '扫码注册投票管理',
    },
  },
  {
    path: '/suggest',
    name: 'Suggest',
    component: Suggest,
    meta: {
      title: '意见建议管理',
      isBlack: true
    },
  },
  {
    path: '/scexpert',
    name: 'Scexpert',
    component: Scexpert,
    meta: {
      title: '双创专家',
      isBlack: true
    },
  },
  {
    path: '/fgexpert',
    name: 'Fgexpert',
    component: Fgexpert,
    meta: {
      title: '发改专家',
      isBlack: true
    },
  },
  {
    path: '/expertInfo',
    name: 'ExpertInfo',
    component: ExpertInfo,
    meta: {
      title: '专家信息管理',
      isBlack: true
    },
  },
  {
    path: '/activeCompany',
    name: 'ActiveCompany',
    component: ScActiveCompany,
    meta: {
      title: '活跃企业',
      isBlack: true
    },
  },
  {
    path: '/importStores',
    name: 'ImportStores',
    component: ScImportStores,
    meta: {
      title: '导入机构/店铺',
      isBlack: true
    },
  },
  {
    path: '/fwsc/activity/activityPage',
    name: 'ActivityManager',
    component: ActivityManager,
    meta: {
      title: '活动管理',
      isBlack: true
    },
  },
  {
    path: '/wximgManager',
    name: 'WximgManager',
    component: WximgManager,
    meta: {
      title: '微信图文消息管理',
      isBlack: true
    },
  },
  {
    path: '/appSurveyManager',
    name: 'AppSurveyManager',
    component: AppSurveyManager,
    meta: {
      title: '企业调研管理',
      isBlack: true
    },
  }
]
